
import { Vue } from "vue-property-decorator";
export default class InitialLoading extends Vue {}
